import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { CommonUtilityLib } from '@thehubz/client/core';

@Directive({
  selector: '[spDataTestAttribute]',
})
export class DataTestAttributeDirective implements OnInit {
  @Input() cellValue = '';
  @Input() optionalId?: string = '';
  constructor(private el: ElementRef, private commonUtilityLib: CommonUtilityLib) {}
  ngOnInit(): void {
    if (typeof this.cellValue === 'string') {
      let dataTestValue = 'default-test-id';
      if (this.cellValue) {
        dataTestValue = this.commonUtilityLib.toCamelCase(this.cellValue);
      }
      if (this.optionalId) {
        dataTestValue += '-' + this.optionalId;
      }
      this.el.nativeElement.setAttribute('data-test-id', dataTestValue);
    }
  }
}
